// VaTest environment configuration
export const environment = {
  production: true,
  name: 'vatest',
  apiBaseUrl: 'https://test-api.myfruit.nl/api/',
  signalRUrl: 'https://test-api.myfruit.nl/hubs/refresh',
  mslConfig: {
    clientId: '72e2352d-4791-4486-91be-1ddd07897762',
    authority:
      'https://vanamerongentechnology.ciamlogin.com/9105822c-62e1-47e2-b590-23ed0d476189/',
    redirectUri: 'https://test-app.myfruit.nl/',
    apiScopes: 'api://e1ffac24-8f5c-44fe-a98c-b9fddf65e5a3/access_as_user',
  },
  debugWorker: false,
  version: '0.0.40',
};
